import React from "react";

type Props = {
  label: string;
  value: string | number;
  sublabel?: string;
};

export default function AdminKpiCard({ label, value, sublabel }: Props) {
  return (
    <div className="app-surface min-w-0 overflow-hidden rounded-[1.5rem] border p-4 sm:rounded-3xl sm:p-5">
      <div className="truncate text-[10px] font-semibold uppercase tracking-[0.18em] text-[color:var(--color-text-subtle)] sm:text-[11px] sm:tracking-[0.3em]">
        {label}
      </div>

      <div className="mt-3 truncate text-2xl font-semibold tracking-tight text-[color:var(--color-page-text)] sm:text-3xl">
        {value}
      </div>

      {sublabel ? (
        <div className="mt-2 truncate text-sm text-[color:var(--color-text-subtle)]">
          {sublabel}
        </div>
      ) : null}
    </div>
  );
}
